




















































import { Component, Vue } from 'vue-property-decorator'

@Component({})
export default class DuplicateElementModal extends Vue {
  private numDuplicate = 1

  private formOk(): boolean {
    return this.numDuplicate !== null && this.numDuplicate > 0
  }

  hideModal() {
    this.clearForm()
    this.$bvModal.hide('duplicateElementModal')
  }

  private clearForm() {
    this.numDuplicate = 1
  }

  duplicateElement() {
    this.$emit('duplicateElementExecute', this.numDuplicate)
    this.hideModal()
  }
}
